<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <h4
                slot="header"
                id="modalTitle"
                class="card-title mb-3 text-align-center"
              >
                {{ `${titulo} Usuário` }}
              </h4>
              <form id="modalDescription">
                <div class="row">
                  <div class="col-md-3">
                    <base-radio
                      v-model="usuario.tipoParceiro"
                      label="pf"
                      name="tipoPessoa"
                      @change="checkedRadio"
                      @input="checkedRadio"
                      >Pessoa Física</base-radio
                    >
                  </div>
                  <div class="col-md-3">
                    <base-radio
                      v-model="usuario.tipoParceiro"
                      label="pj"
                      name="tipoPessoa"
                      @change="checkedRadio"
                      @input="checkedRadio"
                      >Pessoa Jurídica</base-radio
                    >
                  </div>
                </div>

                <div class="row pl-3 pr-3 mb-3">
                  <label for="perfil">Perfil*</label>
                  <select
                    v-model="usuario.tipoUsuario"
                    class="form-control"
                    @change="validaCampos()"
                    :disabled="
                      isColaboradorEditandoAdministrador ||
                        parceiroDefaultOption
                    "
                  >
                    <option
                      v-for="option in selectPermissoesOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                      :selected="option.selected"
                    ></option>
                    <option
                      v-if="
                        isAdministrador || isColaboradorEditandoAdministrador
                      "
                      value="administrador"
                      label="Administrador"
                      key="Administrador"
                    ></option>
                  </select>
                  <span v-if="tipoUsuario == ''"
                    >Este é um campo obrigatório</span
                  >
                </div>

                <div class="row">
                  <div class="col-md-6" v-if="checkedRadio()">
                    <base-input
                      type="text"
                      label="Nome*"
                      max="15"
                      placeholder="Nome"
                      v-model="usuario.nome"
                      @input="validaCampos()"
                      @change="validaCampos()"
                    ></base-input>
                    <span v-if="erro.nome">Este campo é obrigatório</span>
                  </div>
                  <div class="col-md-6" v-if="checkedRadio()">
                    <base-input
                      @change="validaCampos()"
                      @input="validaCampos()"
                      type="text"
                      maxlength="15"
                      label="Sobrenome*"
                      placeholder="Sobrenome"
                      v-model="usuario.sobrenome"
                    ></base-input>
                    <span v-if="erro.sobrenome">Este campo é obrigatório</span>
                  </div>

                  <div class="col-md-6" v-if="!checkedRadio()">
                    <base-input
                      @change="validaCampos()"
                      @input="validaCampos()"
                      type="text"
                      maxlength="30"
                      label="Razão Social*"
                      placeholder="Razão Social"
                      v-model="usuario.razaoSocial"
                    ></base-input>
                    <span v-if="erro.razaoSocial"
                      >Este campo é obrigatório</span
                    >
                  </div>
                  <div class="col-md-6" v-if="!checkedRadio()">
                    <base-input
                      type="text"
                      label="Pessoa para Contato"
                      placeholder="Pessoa para Contato"
                      v-model="usuario.pessoaContato"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <base-input
                      type="email"
                      label="Email"
                      placeholder="Email"
                      v-model="usuario.email"
                    ></base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="CPF"
                      placeholder="CPF"
                      v-model="usuario.cpf"
                      v-if="checkedRadio()"
                      maxlength="14"
                      v-on:keyup="maskCpf(usuario.cpf)"
                    ></base-input>

                    <base-input
                      type="text"
                      label="CNPJ"
                      placeholder="CNPJ"
                      v-model="usuario.cnpj"
                      v-if="!checkedRadio()"
                      maxlength="18"
                      v-on:keyup="maskCnpj(usuario.cnpj)"
                    ></base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input
                      type="tel"
                      label="Telefone"
                      placeholder="Telefone"
                      v-model="usuario.telefone"
                      maxlength="14"
                      v-on:keyup="maskPhone(usuario.telefone)"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="CEP"
                      placeholder="CEP"
                      maxlength="10"
                      v-model="usuario.cep"
                      v-on:keyup="maskCep(usuario.cep)"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="text"
                      maxlength="40"
                      label="Cidade"
                      placeholder="Cidade"
                      v-model="usuario.cidade"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Estado"
                      maxlength="15"
                      placeholder="Estado"
                      v-model="usuario.estado"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Bairro"
                      placeholder="Bairro"
                      v-model="usuario.bairro"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Logradouro"
                      placeholder="Logradouro"
                      v-model="usuario.rua"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="number"
                      label="Número"
                      placeholder="Número"
                      v-model="usuario.numero"
                    ></base-input>
                  </div>
                </div>

                <div class="row pl-3 d-flex justify-content-between">
                  <div class="d-flex align-items-center">
                    <button
                      id="upload_widget"
                      class="d-inline"
                      @click.prevent="uploadImage()"
                      v-if="!(this.usuario && this.usuario.imagem)"
                    >
                      Selecionar imagem
                    </button>
                    <div
                      class="d-inline align-self-center"
                      v-if="this.usuario && this.usuario.imagem"
                    >
                      <img
                        :src="usuario.imagem"
                        alt="Foto do perfil"
                        id="profile-photo"
                      />
                      <button
                        class="btn btn-icon btn-danger ml-2"
                        @click.prevent="deleteImage"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </div>
                  </div>
                  <vue-qrcode
                    v-if="
                      usuario.tipoUsuario === 'colaborador-campo' &&
                        action === 'EDIT'
                    "
                    :value="
                      `http://joule.eco.br/portal/ordem-de-servico/aprovacao/${usuario.codigo}`
                    "
                    :options="{ width: 200 }"
                  ></vue-qrcode>
                </div>
                <div class="text-center mt-4">
                  <button
                    :disabled="
                      tipoUsuario == '' ||
                        (usuario.tipoParceiro == 'pf' &&
                          (erro.sobrenome || erro.nome)) ||
                        (usuario.tipoParceiro == 'pj' && erro.razaoSocial)
                    "
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent
                    @click="salvarUsuario"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Salvar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Fechar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Card from 'src/components/Cards/Card.vue';
import UserServices from 'src/services/usuarios';

import _ from 'lodash';

export default {
  components: {
    Card,
    VueQrcode
  },
  props: {
    parceiroDefaultOption: Boolean,
    action: String,
    afterCreateAction: Function,
    usuario: {
      codigo: '',
      tipoUsuario: '',
      imagem: '',
      nome: '',
      sobrenome: '',
      razaoSocial: '',
      cpf: '',
      cnpj: '',
      pessoaContato: '',
      email: '',
      telefone: '',
      cep: '',
      estado: '',
      cidade: '',
      bairro: '',
      rua: '',
      numero: ''
    }
  },
  data() {
    return {
      loadingConfig: {
        // Pass props by their camelCased names
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourMethodName,
        color: '#000000',
        loader: 'spinner',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      },
      notifications: {
        topCenter: false
      },
      erro: {
        nome: false,
        sobrenome: false,
        tipoUsuario: true,
        razaoSocial: true
      },
      simple: '',
      name: 'modal',
      selectPermissoesOptions: [
        { value: 'vendedor', label: 'Vendedor' },
        { value: 'parceiro', label: 'Parceiro', selected: 'selected' },
        { value: 'colaborador', label: 'Colaborador' },
        { value: 'colaborador-campo', label: 'Colaborador de Campo' }
      ],
      hasImage: false
    };
  },
  computed: {
    titulo() {
      if (this.action === 'EDIT') {
        return 'Editar';
      } else if (this.action === 'NEW') {
        return 'Cadastrar';
      }
    },
    isAdministrador() {
      const userData = this.$store.state.usuario;
      if (_.get(userData, 'tipoUsuario') === 'administrador') {
        return true;
      }
      return false;
    },
    isColaboradorEditandoAdministrador() {
      const userData = this.$store.state.usuario;
      if (
        _.get(userData, 'tipoUsuario') === 'colaborador' &&
        this.usuario.tipoUsuario === 'administrador'
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    checkedRadio() {
      if (this.usuario.tipoParceiro === 'pf') {
        return true;
      }
      if (this.usuario.tipoParceiro === 'pj') return false;
    },
    maskPhone(tel) {
      tel = tel.replace(/\D/g, '');
      tel = tel.replace(/^(\d)/, '($1');
      tel = tel.replace(/(.{3})(\d)/, '$1)$2');
      if (tel.length == 9) {
        tel = tel.replace(/(.{1})$/, '-$1');
      } else if (tel.length == 10) {
        tel = tel.replace(/(.{2})$/, '-$1');
      } else if (tel.length == 11) {
        tel = tel.replace(/(.{3})$/, '-$1');
      } else if (tel.length == 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      } else if (tel.length > 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      }
      this.usuario.telefone = tel;
    },
    maskCep(cep) {
      cep = cep.replace(/\D/g, '');
      cep = cep.replace(/^(\d{2})(\d)/, '$1.$2');
      cep = cep.replace(/\.(\d{3})(\d)/, '.$1-$2');
      this.usuario.cep = cep;
    },
    maskCpf(cpf) {
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      this.usuario.cpf = cpf;
    },
    maskCnpj(cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
      this.usuario.cnpj = cnpj;
    },
    validaCampos() {
      if (this.checkedRadio()) {
        if (this.usuario.nome) {
          this.erro.nome = false;
        } else {
          this.erro.nome = true;
        }

        if (this.usuario.sobrenome) {
          this.erro.sobrenome = false;
        } else {
          this.erro.sobrenome = true;
        }
      } else {
        if (this.usuario.razaoSocial) {
          this.erro.razaoSocial = false;
        } else {
          this.erro.razaoSocial = true;
        }
      }
    },
    salvarUsuario() {
      const loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourMethodName,
        color: '#049F0C',
        loader: 'spinner',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Salvo com Sucesso.',
          'fa fa-check'
        );
        this.afterCreateAction();
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      let userToPost;
      try {
        userToPost = this.preProcessingUser();
      } catch (e) {
        errorCallback('Dados incorretos');
        return;
      }
      if (userToPost._id) {
        UserServices.atualizar(userToPost)
          .then(sucessCallback)
          .catch(errorCallback);
      } else {
        UserServices.salvar(userToPost)
          .then(sucessCallback)
          .catch(errorCallback);
      }
    },
    preProcessingUser() {
      const regex = /[^0-9]/g;
      let userPreProcessed = { ...this.usuario };
      if (userPreProcessed.tipoParceiro === 'pf') {
        userPreProcessed.cpf = userPreProcessed.cpf.replace(regex, '');

        userPreProcessed.razaoSocial = undefined;
        userPreProcessed.cnpj = undefined;
        userPreProcessed.pessoaContato = undefined;
      } else {
        userPreProcessed.cnpj = userPreProcessed.cnpj.replace(regex, '');

        userPreProcessed.nome = undefined;
        userPreProcessed.sobrenome = undefined;
        userPreProcessed.cpf = undefined;
      }
      userPreProcessed.cep = userPreProcessed.cep.replace(regex, '');
      userPreProcessed.telefone = userPreProcessed.telefone.replace(regex, '');
      return userPreProcessed;
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    uploadImage() {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          multiple: false,
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.usuario.imagem = result.info.url;
            this.validaCampos();
            let sobrenome = this.usuario.sobrenome;
            this.usuario.sobrenome = sobrenome + ' ';
            this.usuario.sobrenome = sobrenome;
          }
        }
      );
      myWidget.open();
    },
    deleteImage() {
      this.usuario.imagem = '';
      let sobrenome = this.usuario.sobrenome;
      this.usuario.sobrenome = sobrenome + ' ';
      this.usuario.sobrenome = sobrenome;
    }
  }
};
</script>
<style>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  position: relative;
}

#profile-photo {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}
</style>
